import React from 'react';

const Assured = props => {
  return (
    <svg viewBox="0 0 170.3 68.5" {...props}>
      <path
        fill="#FFFFFF"
        d="M157.5,
23.6v20.3H69.7V23.6H157.5z M30.8,2.9L30.8,2.9L3.3,17.2c0,0-7,36.7,27.2,
48c0,0,13.7-6.3,17.7-10.7 c4.7-5,7.3-10.8,8.8-16.3c3-11.1,1.1-21,1.1-21L30.8,2.9z"
      ></path>
      <path
        opacity="0.15"
        fill="#0FAA14"
        d="M34.2,5.8L7.5,20.2c0,0-5.5,33.1,28,
43.1L31,65.5c0,0-32.9-8.2-27.6-48L30.8,3.2L34.2,5.8z"
      ></path>
      <path
        fill="#0FAA14"
        d="M129,32.2c0,0.5-0.2,1-0.5,1.3c-0.4,0.3-0.8,0.5-1.4,0.5h-2.9v-3.4h2.9c0.5,
0,1,0.2,1.4,0.5 C128.8,31.3,129,31.7,129,32.2z M75.2,36.3h4l-2-5.5L75.2,36.3z M149.9,
30.5h-2.3v7.9h2.3c0.8,0,1.5-0.2,2.1-0.5 c0.6-0.4,1.1-0.8,1.4-1.4c0.3-0.6,
0.5-1.3,0.5-2c0-1.2-0.3-2.1-1-2.8C152.1,30.9,151.1,30.5,149.9,30.5z M35.4,
43.4l-2-3.4 c-1.6-2.7-3.1-2.9-4.9-2.9l-1.1,0c-1.5,0-3-0.1-4-1.5c-0.5-0.8-0.7-1.9-0.7-3.5c0.1-2.2,
1.2-6,2.8-7.5c0.7-0.6,1.6-1.2,2.8-1.5 c1.3-0.3,2.6-0.4,3.9-0.3c3,0.2,4.2,1.7,4.5,
3.6c0.2,1.7-0.7,5.3-1.4,6.9c-0.6,1.3-1.3,2.3-2.3,2.9c0.6,0.4,1.3,1.1,1.9,
2.2 l1.6,2.8c0.9-0.5,1.7-1,2.4-1.7c3.2-3.1,4.9-10.2,
4.5-14.5c-0.4-4.5-3.5-6.9-7.7-7.5c-1.9-0.3-4.2-0.3-5.5-0.3 c-3.4,
0.1-6.9,1.1-9.5,3.5c-2,1.9-3.1,4.5-3.8,7.6c-0.3,1.2-0.6,2.6-0.7,3.8c-0.1,1.1-0.1,2.1-0.1,3c0.3,
3.8,2.6,5.9,5.4,7 c1.1,0.4,3.2,0.7,5,0.8c1.6,0.1,1.6,0.4,2.5,1.8l2.3,
4c1.6,2.7,4.2,2.9,6.1,2.9h6.9l1.2-5.9h-6.1C36.7,45.7,36.6,45.2,
35.4,43.4z M58.2,38.8c-1.7,6.5-4.8,12.1-9,16.7c-4.6,4.9-10.6,8.6-17.8,11h0l-0.5,
0.2l-0.5-0.2C-4.3,55.1,2.4,17.8,2.4,17.4l0.1-0.5 L30.6,2.2h0.5l0.2,
0.1l27.8,14.6l0.1,0.5C59.3,17.8,61.2,27.6,58.2,38.8z M57.4,
18.2L30.9,4.3L4.3,18.2c-0.7,4.4-4.7,36,26.5,46.3 c6.9-2.3,12.5-5.8,16.8-10.4c4-4.3,6.9-9.7,
8.6-15.9C58.8,28.9,57.7,20.3,57.4,18.2z M167.6,34.5c0,9.5-7.7,17.1-17.1,17.1H57.3 c8.7-12.1,
7.2-30,6.7-34.2h86.5C160,17.4,167.6,25.1,167.6,34.5z M83.7,40.8l-4.9-12.7h-3.4l-4.9,
12.7h3.1l0.8-2.1h5.4l0.8,2.1 H83.7z M94.4,
37c0-0.6-0.1-1.1-0.3-1.5c-0.2-0.4-0.5-0.8-0.8-1.1c-0.3-0.3-0.7-0.5-1.2-0.7c-0.4-0.2-0.9-0.4-1.3-0.5
c-0.5-0.1-0.9-0.2-1.3-0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-0.3-0.1-0.6-0.2-0.8-0.4
c-0.2-0.2-0.3-0.4-0.3-0.6c0-0.4,
0.2-0.7,0.5-0.9 c0.3-0.2,0.8-0.3,1.3-0.3c0.7,0,1.3,0.1,2,0.4s1.2,0.6,1.7,
1l1.5-2c-1.3-1.2-2.9-1.8-4.9-1.8c-1.5,0-2.6,0.4-3.5,1.1 s-1.3,1.6-1.3,2.7c0,0.6,0.1,1.1,0.3,1.5c0.2,
0.4,0.5,0.8,0.8,1c0.3,0.3,0.7,0.5,1.2,0.7c0.4,0.2,0.9,0.3,1.3,0.4 c0.5,0.1,
0.9,0.2,1.3,0.3c0.4,0.1,0.8,0.2,1.2,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.2,
0.2,0.3,0.4,0.3,0.7c0,0.4-0.2,0.7-0.6,1 c-0.4,0.3-0.9,0.4-1.6,0.4c-0.8,
0-1.6-0.2-2.3-0.5c-0.7-0.3-1.3-0.7-1.8-1.3l-1.5,2.1c1.3,1.3,3.2,2,5.4,
2c1.6,0,2.9-0.4,3.8-1.1 C93.9,39.2,94.4,38.2,94.4,37z M105.8,
37c0-0.6-0.1-1.1-0.3-1.5c-0.2-0.4-0.5-0.8-0.8-1.1c-0.3-0.3-0.7-0.5-1.2-0.7
c-0.4-0.2-0.9-0.4-1.3-0.5c-0.5-0.1-0.9-0.2-1.3-0.3c-0.4-0.1-0.8-0.2-1.2-0.3
c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.3-0.4-0.3-0.6 c0-0.4,
0.2-0.7,0.5-0.9c0.3-0.2,0.8-0.3,1.3-0.3c0.7,0,1.3,0.1,2,0.4s1.2,0.6,1.7,
1l1.5-2c-1.3-1.2-2.9-1.8-4.9-1.8 c-1.5,0-2.6,0.4-3.5,1.1s-1.3,1.6-1.3,2.7c0,
0.6,0.1,1.1,0.3,1.5c0.2,0.4,0.5,0.8,0.8,1c0.3,0.3,0.7,0.5,1.2,
0.7 c0.4,0.2,0.9,0.3,1.3,0.4c0.5,0.1,0.9,0.2,1.3,0.3c0.4,0.1,0.8,0.2,1.2,0.3c0.3,
0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.4,0.3,0.7 c0,0.4-0.2,0.7-0.6,
1c-0.4,0.3-0.9,0.4-1.6,0.4c-0.8,0-1.6-0.2-2.3-0.5c-0.7-0.3-1.3-0.7-1.8-1.3l-1.5,
2.1c1.3,1.3,3.2,2,5.4,2 c1.6,0,2.9-0.4,3.8-1.1C105.3,39.2,105.8,38.2,105.8,37z M119,
28.2h-2.7v7.5c0,0.9-0.3,1.6-0.8,2.2s-1.2,0.8-2.2,0.8 c-1,
0-1.7-0.3-2.2-0.8c-0.5-0.5-0.8-1.3-0.8-2.2v-7.5h-2.7v7.6c0,1.6,0.5,2.9,1.5,3.9c1,
1,2.4,1.4,4.3,1.4c0.9,0,1.8-0.1,2.5-0.4 c0.7-0.3,1.3-0.6,1.8-1.1c0.5-0.5,0.8-1,1-1.7c0.2-0.6,
0.4-1.4,0.4-2.2V28.2z M131.8,40.8L129,36c0.4-0.1,0.7-0.2,1-0.4 c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.3,
0.5-0.7,0.7-1.1c0.2-0.5,0.2-0.9,
0.2-1.5c0-1.2-0.4-2.2-1.2-2.9c-0.8-0.8-1.8-1.1-3.1-1.1h-5.9 v12.7h2.7v-4.5h2l2.5,
4.5H131.8z M142.7,
28.2h-9v12.7h9v-2.4h-6.3v-2.9h6.1v-2.4h-6.1v-2.7h6.3V28.2z M156.6,
34.5 c0-1.9-0.6-3.4-1.9-4.6c-1.2-1.2-2.9-1.7-4.9-1.7h-5v12.7h5c1.3,
0,2.5-0.3,3.5-0.8c1-0.5,1.8-1.3,2.4-2.2 C156.3,
36.9,156.6,35.8,156.6,34.5z"
      ></path>
    </svg>
  );
};
export default Assured;
